import { css } from "@emotion/react";

import theme from "../../styles/theme";
import { drawerWidth, greyLight, black, greySecondary } from "../../styles/variables";

const { spacing, palette } = theme;

export const appBar = css`
  padding-left: ${drawerWidth};
  color: ${black};
  background: ${greyLight};
  box-shadow: none;
`;

export const toolBar = css`
  border-bottom: 2px solid ${greySecondary};
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const toolBarHeader = css`
  width: 100%;
  height: 64px;
  display: flex;
  position: relative;
  align-items: center;
`;

export const back = css`
  margin-right: ${spacing(2)}px;
`;

export const title = css`
  flex: 1;
  font-weight: 500;
`;

export const btn = css`
  margin-left: ${spacing(1.5)}px;
`;

export const icon = css`
  margin-right: ${spacing(2)}px;
  color: ${palette.primary.main};
`;

export const tabs = css`
  margin-bottom: -2px;
`;
